import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translation_pl from './translation_pl.json';
import translation_en from './translation_en.json';

import { Language, defaultLanguage, localStorageLanguageKey } from './language';

export const getDefaultLanguage = () => {
  const languageFromStorage = localStorage.getItem(localStorageLanguageKey);

  return languageFromStorage && Object.values(Language).includes(languageFromStorage) ? languageFromStorage : defaultLanguage;
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      'pl-PL': {
        translation: translation_pl,
      },
      'en-US': {
        translation: translation_en,
      },
    },
    lng: getDefaultLanguage(),
    fallbackLng: Language.EN,

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },

    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true,
    },
  });

export default i18n;
